export enum PersonalizedSeenFilter {
  All = 'all',
  Seen = 'seen',
  Unseen = 'unseen',
}

export function normalizePersonalizedSeenFilter(value?: string): PersonalizedSeenFilter {
  switch (value) {
    case PersonalizedSeenFilter.Seen:
      return PersonalizedSeenFilter.Seen;
    case PersonalizedSeenFilter.Unseen:
      return PersonalizedSeenFilter.Unseen;
    default:
      return PersonalizedSeenFilter.All;
  }
}
